module.exports = __webpack_public_path__ + "static/media/ListingValidIcon.81f12d31.svg";